import { render, staticRenderFns } from "./DTSHCreate.vue?vue&type=template&id=6e2d6f5a&"
import script from "./DTSHCreate.vue?vue&type=script&lang=js&"
export * from "./DTSHCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports